import styled from 'styled-components';

export const Container = styled.div`
  max-width: 1520px;
  margin: 0 auto;
  padding: 30px 60px;
`;
